import dayjs from "dayjs";
import "dayjs/locale/pl";
import isTomorrow from "dayjs/plugin/isTomorrow";

dayjs.extend(isTomorrow);

export function formatOnAir(d: string): string {
  const today = dayjs();
  const date = dayjs(d);
  const daysDifference = dayjs(date).diff(today, "d");
  const dayInWeek = new Date(d).getDay();
  const isToday = date.isSame(today, "d");
  const isTommorrow = date.isTomorrow();
  const isDayAfterTommorrow =
    date.format("YYYY-MM-DD") === today.add(2, "day").format("YYYY-MM-DD");

  if (isToday || (isTommorrow && date.hour() === 0)) {
    return "Dzisiaj";
  }

  if (isTommorrow) {
    return "Jutro";
  }

  if (isDayAfterTommorrow) {
    return "Pojutrze";
  }

  if (daysDifference >= 2 && daysDifference < 7) {
    switch (dayInWeek) {
      case 1:
        return "Najbliższy poniedziałek";
      case 2:
        return "Najbliższy wtorek";
      case 3:
        return "Najbliższa środa";
      case 4:
        return "Najbliższy czwartek";
      case 5:
        return "Najbliższy piątek";
      case 6:
        return "Najbliższa sobota";
      case 0:
      case 7:
        return "Najbliższa niedziela";
    }
  } else if (daysDifference >= 7 && daysDifference < 14) {
    switch (dayInWeek) {
      case 1:
        return "Następny poniedziałek";
      case 2:
        return "Następny wtorek";
      case 3:
        return "Następna środa";
      case 4:
        return "Następny czwartek";
      case 5:
        return "Następny piątek";
      case 6:
        return "Następna sobota";
      case 7:
        return "Następna niedziela";
    }
  } else {
    return dayjs(date).format("dddd, DD.MM");
  }
}
